export default __webpack_public_path__ + "static/media/favorite-glyph-red-16px.302644a6.svg";